import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.usage-data', {
        url: '/usage-data',
        component: 'companyManageApplicationUsageData',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/usage-data/usage-data.state.js